// editor type represents each editor that the EdiForm needs to support
// and render unique content based off of
export default Object.freeze({
  BLOGS: 'BLOGS',
  EMAIL: 'EMAIL',
  GLOBAL_CONTENT: 'GLOBAL_CONTENT',
  PAGES: 'PAGES',
  DESIGN_MANAGER: 'DESIGN_MANAGER'
});